import { actionType } from '../types/type';
import { Dispatch } from 'redux';
import * as services from '../services/services';
import URLConstants from '../constants/url.constants';
import userSettingEnum from '../../constants/userSetting.enum';
import { toast } from 'react-toastify';
import { formatMessage } from '../../translations/connectedIntlProvider';

export const defaultStateDispatcher = () => {
	return {
		type: actionType.DEFAULT_STATE
	};
};

const changeLanguageDispatcher = (data: string) => {
	return {
		type: actionType.CHANGE_LANGUAGE,
		payload: data
	};
};

export const changeLanguage = (lang: string) => {
	return (dispatch: Dispatch) => {
		localStorage.setItem('language', lang);
		dispatch(changeLanguageDispatcher(lang));
	};
};

const updateLanguageSuccess = (data: any) => {
	return {
		type: actionType.UPDATE_LANGUAGE,
		payload: data
	};
};

export const updateLanguage = () => {
	return (dispatch: Dispatch) => {
		let data = {
			language: localStorage.getItem('language'),
		}
		if (data.language != null)
			dispatch(updateLanguageSuccess(data));
	};
};

export const resetIsLanguageChanged = () => {
	return (dispatch: Dispatch) => {
		dispatch(resetIsLanguageChangedDispatcher());
	};
};

const resetIsLanguageChangedDispatcher = () => {
	return {
		type: actionType.RESET_IS_LANGUAGE_CHANGED
	};
};


const pageLimitChangedDispatcher = (data: number) => {
	return {
		type: actionType.PAGE_LIMIT_UPDATED,
		payload: data
	};
};

export const updatePagerPageLimit = (pageLimit: number) => {
	return (dispatch: Dispatch) => {
		const userData = { key: userSettingEnum.PageLimit, value: pageLimit.toString() }
		let url = URLConstants.AddUserSettings;
		services.post(url, userData)
			.then(response => {
				dispatch(pageLimitChangedDispatcher(pageLimit));
			})
			.catch(err => {
				toast.error(formatMessage('Message_Some_Error_Occured'));
				console.log(err);
			});
	};
};

const getPageLimitSuccess = (data: number) => {
	return {
		type: actionType.GET_PAGE_LIMIT,
		payload: data
	};
};

export const getPageLimit = () => {
	return (dispatch: Dispatch) => {
		let url = URLConstants.GetUserSettings + '/' + userSettingEnum.PageLimit;
		services.get(url)
			.then(response => {
				const pageLimit = response.data && response.data !== null && response.data !== undefined ? Number(response.data.Value) : 100
				dispatch(getPageLimitSuccess(pageLimit));
			})
			.catch(err => {
				toast.error(formatMessage('Message_Some_Error_Occured'));
				console.log(err);
			});
	};
};

const resetPageLimitDispatcher = () => {
	return {
		type: actionType.RESET_PAGE_LIMIT,
	};
};

export const resetPageLimit  = () => {
	return (dispatch: Dispatch) => {
		dispatch(resetPageLimitDispatcher());
	};
}; 